module.exports = __webpack_public_path__ + "static/media/CM.9ea48291.jpg";